module.exports = __webpack_public_path__ + "img/nombre.d6d5a595.svg";